<template>
  <div class="licence-upload-wrapper">
    <HeraFormInputFile
      id="licence"
      ref="licenceFile"
      output-as="binary"
      :accept="['pdf', 'PDF']"
      name="licence"
      :size-ceil="3e4"
      :label="$$t('licence File:')"
      :preupload="true"
      :disabled="isTournamentFieldDisabled('licence_link')"
      hide-default-loader
      @filesSelected="info => onFileSelected('licence')(info)"
      @filesUploaded="info => onFileUploaded('licence')(info)"
      @uploadError="onFileError('licence')"
    />
    <div
      v-if="licenceLink || licence"
      class="d-flex align-items-center action-remove mt-3"
    >
      <a v-if="licenceLink && !licence" :href="licenceLink" target="_blank">
        {{ $$t('licence link.pdf', 'licence-placeholder') }}
      </a>
      <div v-else-if="licence">{{ licence }}</div>
      <Icon
        v-if="licenceLink"
        class="cursor-pointer h-ml-3"
        :fill="primaryFill"
        name="delete"
        hover-icon="delete-active"
        @click="removelicenceLink"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '@/components/atoms/Icon';
import HeraFormInputFile from '@/components/form/HeraFormInputFile';
import { translate } from '@/mixins/translate';
const component = 'info';

export default {
  name: 'TournamentlicenceFileSetting',
  inject: ['$validator'],
  components: {
    Icon,
    HeraFormInputFile,
  },

  mixins: [translate('_web_tournament_additional_settings')],
  data() {
    return {
      primaryFill: this.$scss.colors.primaryTextBg,
      licence: '',
    };
  },
  computed: {
    ...mapGetters([
      'currentTournament',
      'currentTournamentInfo',
      'isTournamentFieldDisabled',
    ]),
    componentData() {
      return this.currentTournamentInfo;
    },
    licenceLink: {
      get() {
        return this.$lodash.get(this.componentData, 'license.file', '');
      },
      set(newVal) {
        this.updateCurrentTournament({
          license: { ...this.componentData.license, file: newVal },
          component,
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    onFileSelected(property) {
      return filesInfo => {
        this[property] = filesInfo[0].name;
      };
    },
    onFileUploaded() {
      return filesInfo => {
        this.licenceLink = filesInfo[0].file_id;
        this.errors.remove('licence');
      };
    },
    onFileError(property) {
      this[property] = '';
    },
    removelicenceLink() {
      this.licenceLink = '';
      this.licence = '';
      if (this.$refs.licenceFile) {
        this.$refs.licenceFile.clearFileInput();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.licence-upload-wrapper {
  max-width: 220px;
}
</style>
